import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { format } from "date-fns";

import buttonStyles from "../../../../styles/Button.module.css";
import "./createAsociados.css";
import styles from "../../../../styles/Username.module.css";
import extend from "../../../../styles/Profile.module.css";
import avatar from "../../../../assets/profile.png";
import "./../formsCommons.css";

import * as SVGImages from "../../svg";

import { createAsociadoFormValidate } from "../../../../helper/validate";
import * as api from "helper/helper";
//INVESTIGAR import { useFormInput } from "../../../../hooks/custom.hooks";
import convertToBase64 from "../../../../helper/convert";
import AddressTag from "../Address/AddressTag";
import CreateAddressModal from "../Address/CreateAddressModal";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import LoadingButton from "../LoadingButton/LoadingButton";
import { useAuthStore } from "../../../../store/store";

const CreateAsociado = forwardRef(({ item, reloadAsociados }, ref) => {
  const [file, setFile] = useState();
  const [modalData, setModalData] = useState(null);
  const [direcciones, setDirecciones] = useState([]);
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [fotoUrl, setFotoUrl] = useState("");

  const [sexos] = useState([
    { id: 0, name: "Selecciona Sexo..." },
    { id: "Hombre", name: "Hombre" },
    { id: "Mujer", name: "Mujer" },
    { id: "x", name: "X" },
  ]);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const isSaveDisable = useRef();
  const fieldsSetup = useRef({});

  const modalRef = useRef();
  const buttonCancelModalRef = useRef();
  const createAddressRef = useRef();

  const createMode = item == null || (item && Object.keys(item).length === 0);

  const isAdmin = useAuthStore((state) => state.isAdmin);

  /** formik doesn't support file up`load so we need to create this handler */
  const onUpload = async (e) => {
    const base64 = await convertToBase64(e.target.files[0]);
    setFile(base64);
  };

  useEffect(() => {
    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    formik?.resetForm();

    setupFields();
    isSaveDisable.current =
      (createMode && !permissions.canCreate) ||
      (!createMode && !permissions.canEdit);

    setDirecciones([]);

    setFotoUrl("");
    if (item?.rutaFoto) {
      processFoto(item.rutaFoto);
    }

    //const imgId = "drive.google.com/file/d/([\w.-]+)"gmi
  }, [item]);

  useEffect(() => {
    setDirecciones(item?.direcciones ?? []);
  }, [item?.direcciones]);

  let initialValues = {
    id: 0,
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    fechaNacimiento: "",
    documentacion: false,
    rutaDocumentacion: "",
    rutaFoto: "",
    correo: "",
    celular: "",
    rfc: "",
    curp: "",
    nacionalidad: "MEXICANA",
    sexo: "X",
    empleado: false,
    direcciones: [],
    activo: true,
  };

  if (!createMode) {
    const fechaNacimiento = format(item.fechaNacimiento, "yyyy-MM-dd");

    initialValues = {
      id: item.id,
      activo: item.activo,
      empleado: item.empleado,
      nombre: item.nombre,
      apellidoPaterno: item.apellidoPaterno,
      apellidoMaterno: item.apellidoMaterno,
      correo: item.correo,
      celular: item.celular,
      rfc: item.rfc,
      curp: item.curp,
      nacionalidad: item.nacionalidad,
      sexo: item.sexo,
      fechaNacimiento: fechaNacimiento,
      documentacion: item.documentacion,
      rutaDocumentacion: item.rutaDocumentacion ?? "",
      rutaFoto: item.rutaFoto ?? "",
      sucursal: "",
      nivel: item.nivel?.nombre,
      limiteCredito: "",
      creditoActual: "",
      direcciones: item.direcciones,
    };
  }

  const formik = useFormik({
    initialValues: { ...initialValues },
    enableReinitialize: true,
    validate: createMode ? createAsociadoFormValidate : null,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      setIsLoading(true);
      if (direcciones.length > 0) {
        for (let index = 0; index < direcciones.length; index++) {
          let direccion = direcciones[index];
          if (direccion.id > 0) {
            continue;
          }

          delete direccion.id;
          delete direccion.isNew;
        }
        values.direcciones = direcciones;
      }

      if (values.id === 0) {
        const toastId = toast.loading("Creando Asociado...");
        let response = await api.createAsociado(values).catch((e) => {
          toast.dismiss(toastId);
          setIsLoading(false);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al crear Asociado. ${e.mensaje}`);
            return;
          }
          toast.error("Error al crear Asociado.");
        });

        toast.dismiss(toastId);
        setIsLoading(false);

        if (!response) return;

        toast.success("Asociado creado.");
        reloadAsociados();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Asociado...");
        const response = await api
          .updateAsociado(values.id, values)
          .catch((e) => {
            toast.dismiss(toastId);
            setIsLoading(false);
            toast.error("Error al actualizar Asociado.");
          });
        if (!response) return;

        const responseActivo = await api
          .activarAsociado(values.id, values.activo)
          .catch((e) => {
            toast.dismiss(toastId);
            setIsLoading(false);
            toast.error("Error al actualizar activo Asociado.");
          });

        if (isAdmin) {
          const response = await api
            .actualizarEmpleado(values.id, values.empleado)
            .catch((e) => {
              toast.dismiss(toastId);
              setIsLoading(false);
              toast.error("Error al actualizar Empleado.");
            });
        }

        toast.dismiss(toastId);
        setIsLoading(false);

        if (!responseActivo) return;

        toast.success("Asociado actualizado.");
        reloadAsociados();

        buttonCancelModalRef.current.click();
      }
    },
  });

  //formik.setFieldValue("direcciones", updated);
  /*  const handleChange = async (event: { target: { value: SetStateAction<string> } }) => {
    const token = allowedTokenList.find(token => token.address === event.target.value);
    setSelectedToken(token);
    formikProps.setFieldValue('rateToken', event.target.value);
  };*/
  /*  const formikExtra = {
    upperCase: (name, formik) => {
      return {
        onChange: (event) => {
          //      onChange={(e)=>{ const value = e.target.value || ""; setFieldValue('email', value.toLowerCase()); }}
          const value = event.target.value || "";
          formik.setFieldValue(name, value.toUpperCase());
        },
      };
    },
  };*/

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  function processFoto(originalUrl) {
    if (originalUrl == null) {
      return;
    }
    //  const yes = "https://drive.google.com/file/d/1wjMP3aiMgdNkjTKFeaFKL8G5CMVSGVT9/view";
    const yo = originalUrl.match(
      new RegExp(/drive.google.com\/file\/d\/([\w.-]+)/),
    );
    if (yo != null && yo.length > 1) {
      const imgId = yo[1];

      const final = `https://drive.google.com/thumbnail?id=${imgId}`;

      setFotoUrl(final);
    }

    console.log(yo);
  }

  /*
    AddressTag handle
    */
  function createEditAddress(event, item = null) {
    setModalData(item);
    createAddressRef.current.toggleModal();
  }

  function deleteAddress(event, deleteItem) {
    const updated = direcciones.filter((item) => item.id !== deleteItem.id);
    setDirecciones(updated);
    //formik.setFieldValue("direcciones", updated);
    //formik.values.direcciones = updated;
  }

  /** manage address add/edit */
  function handleAddressViewChanges(item) {
    /*
      item.isNew
      item.id -> contiene {num} = editado
      */
    if (item.isNew) {
      delete item.isNew;
      item.id = -Date.parse(Date());
      const newDirecciones = direcciones.concat(item);
      setDirecciones(newDirecciones);
    } else {
      const index = direcciones.findIndex((value) => item.id === value.id);
      if (index !== -1) {
        direcciones.splice(index, 1, item);
        const allDirecciones = [...direcciones];
        setDirecciones(allDirecciones);
      }
    }
  }

  /*function onChange(e) {
      formik.setValues({
        ...formik.values,
        activo: e.target.checked,
        //  restrito: Boolean(link.restrito),
      });
    }*/

  //const ws = new WebSocket('ws://localhost:8080');

  //new Proxy()
  /*
    const updated = direcciones.filter((item) => item.id !== deleteItem.id);
    setDirecciones(updated);
    formik.setFieldValue("direcciones", updated);
*/

  function setupFields() {
    // fieldsSetup
    fieldsSetup.current = {};

    for (const [key, value] of Object.entries(initialValues)) {
      console.log(`${key}: ${value}`);

      const res = api.isFieldReadOnlyWith(createMode, value);
      fieldsSetup.current[key] = res;
    }
  }

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearAsociado"
        hidden
      >
        Abrir Crear asociado
      </button>

      <div
        className="modal fade"
        id="staticBackdropCrearAsociado"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearAsociadoLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropCrearAsociadoLabel">
                {createMode ? "Crear" : "Editar"} Asociado
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="">
                <div className="row">
                  {!createMode && item.congelado && (
                    <div className="alert alert-warning" role="alert">
                      Este usuario se encuentra en modo <b>Congelado</b>{" "}
                      <span>
                        <img
                          alt=""
                          src={SVGImages.SNOWFLAKE}
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "5px",
                          }}
                        />
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <form
                className="row g-3"
                onSubmit={(event) => {
                  event.preventDefault();
                  return false;
                }}
              >
                <div
                  className="profile flex justify-center"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <label htmlFor="profile">
                    <img
                      className={`${styles.profile_img} ${extend.profile_img}`}
                      style={{ height: "100px", width: "100px" }}
                      src={file || fotoUrl || avatar}
                      alt="avatar"
                    />
                  </label>

                  <input
                    onChange={onUpload}
                    type="file"
                    id="profile"
                    name="profile"
                    hidden={true}
                    disabled={true}
                  />
                </div>

                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                >
                  <div className="input-group">
                    <div className="input-group-text">
                      <input
                        className="form-check-input mt-0"
                        type="checkbox"
                        aria-label="Checkbox for following text input"
                        {...formik.getFieldProps("documentacion")}
                        checked={formik.values.documentacion}
                      />
                    </div>
                    <span className="input-group-text">
                      Documentación Completa
                    </span>
                  </div>

                  <div className="form-check form-switch container-center-vertical">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      {...formik.getFieldProps("activo")}
                      checked={formik.values.activo}
                      disabled={
                        isActiveDisabled ||
                        !permissions.canActivar ||
                        fieldsSetup.current.activo ||
                        (!createMode && item.congelado)
                      }
                    />
                    <span>
                      <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault"
                      >
                        Activo
                      </label>
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="row">
                    {/*<div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Numero Asociado
                      </label>
                      <input
                        type="text"
                        className={`form-control  ${invalidClass(
                          formik.errors.numAsociado
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("numAsociado")}
                        {...formikExtra.upperCase("numAsociado", formik)}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.numAsociado}
                      </div>
                    </div>*/}

                    <div className="col align-container-center">
                      <div className="container-center-horizontal">
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.rutaFoto}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon3">
                    Foto Url
                  </span>
                  <input
                    type="text"
                    className={`form-control ${invalidClass(
                      formik.errors.rutaFoto,
                    )}`}
                    aria-label="Text input with segmented dropdown button"
                    placeholder="Foto Url"
                    {...formik.getFieldProps("rutaFoto")}
                    onChange={(e) => {
                      formik.setFieldValue("rutaFoto", e.target.value);
                      /*
                          const re = "https://drive.google.com/file/d/1wjMP3aiMgdNkjTKFeaFKL8G5CMVSGVT9/view"

                          const imgId = "drive.google.com/file/d/([\w.-]+)"gmi

                          const thumbnailUrl = `https://drive.google.com/thumbnail?id=${imgId}`
                          //`https://drive.google.com/thumbnail?id=1hgbBlRxvPjWXPn0nuxORQwTcxr7Jv2Q5`
                          setFotoUrl

*/

                      processFoto(e.target.value);
                    }}
                  />
                </div>

                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon3">
                    Doc Url
                  </span>
                  <input
                    type="text"
                    className={`form-control ${invalidClass(
                      formik.errors.rutaDocumentacion,
                    )}`}
                    aria-label="Text input with segmented dropdown button"
                    placeholder="Documentación Url"
                    {...formik.getFieldProps("rutaDocumentacion")}
                  />
                  <div className="valid-feedback">Looks good!</div>
                  <div className="invalid-feedback">
                    {formik.errors.rutaDocumentacion}
                  </div>
                </div>

                <div className="separator"></div>

                <div className="bd-example-row1">
                  <div className="">
                    <div className="row gy-1">
                      <div className="">
                        <label
                          htmlFor="validationApellidoPaterno"
                          className="form-label"
                        >
                          Nombre
                        </label>
                        <input
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.nombre,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          {...formik.getFieldProps("nombre")}
                          {...formikExtra.upperCase("nombre", formik)}
                        />
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.nombre}
                        </div>
                      </div>

                      <div className="">
                        <label
                          htmlFor="validationApellidoPaterno"
                          className="form-label"
                        >
                          Apellido Paterno
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationApellidoPaterno"
                          aria-describedby="eeee"
                          {...formik.getFieldProps("apellidoPaterno")}
                          {...formikExtra.upperCase("apellidoPaterno", formik)}
                        />
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          Please choose a username.
                        </div>
                        {/*<div id="emailHelp" className="form-text"></div>*/}
                      </div>

                      <div className="">
                        <label
                          htmlFor="validationApellidoMaterno"
                          className="form-label"
                        >
                          Apellido Materno
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationApellidoMaterno"
                          aria-describedby="emailHelp"
                          {...formik.getFieldProps("apellidoMaterno")}
                          {...formikExtra.upperCase("apellidoMaterno", formik)}
                        />
                        <div className="valid-feedback">
                          Looks good! WPWPWPW
                        </div>
                        <div className="invalid-feedback">
                          Please choose a username. BOOM
                        </div>
                        <div id="emailHelp11" className="form-text"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="separator"></div>

                <div className="mb-3">
                  <div className="row">
                    <div className="col align-container-center">
                      <label htmlFor="validationDOB" className="form-label">
                        Fecha de Nacimiento
                      </label>
                      <input
                        type="date"
                        min="1900-01-01"
                        className={`form-control ${invalidClass(
                          formik.errors.fechaNacimiento,
                        )}`}
                        id="validationDOB"
                        aria-describedby="emailHelperwerwer"
                        placeholder="YYYY-MM-DD"
                        {...formik.getFieldProps("fechaNacimiento")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "fechaNacimiento",
                            e.target.value,
                          );
                        }}
                      />
                      <div className="valid-feedback">Looks good!</div>
                      <div className="invalid-feedback">
                        {formik.errors.fechaNacimiento}
                      </div>
                    </div>
                    <div className="col align-container-center">
                      <div className="container-center-horizontal">
                        <div className="form-check form-switch container-center-vertical">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchEmpleadoCheckDefault"
                            {...formik.getFieldProps("empleado")}
                            checked={formik.values.empleado}
                            disabled={fieldsSetup.current.empleado || !isAdmin}
                          />
                          <span>
                            <label
                              className="form-check-label"
                              htmlFor="flexSwitchEmpleadoCheckDefault"
                            >
                              Empleado
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="row">
                    <div className="col align-self-start">
                      <label htmlFor="validationEmail" className="form-label">
                        Email
                      </label>
                      <input
                        {...formik.getFieldProps("correo")}
                        {...formikExtra.upperCase("correo", formik)}
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.correo,
                        )}`}
                        id="validationEmail"
                        aria-describedby="emailHelp777"
                      />
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.correo}
                      </div>
                      <div id="emailHelprtrt" className="form-text"></div>
                    </div>
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Celular
                      </label>
                      <input
                        {...formik.getFieldProps("celular")}
                        {...formikExtra.upperCase("celular", formik)}
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.celular,
                        )}`}
                        id="validationEmail"
                        aria-describedby="emailHelp777"
                      />
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.celular}
                      </div>
                      <div id="emailHelp" className="form-text"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col align-self-center">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        RFC
                      </label>
                      <input
                        {...formik.getFieldProps("rfc")}
                        {...formikExtra.upperCase("rfc", formik)}
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.rfc,
                        )}`}
                        id="validationEmail"
                        aria-describedby="emailHelp777"
                      />
                      <div id="emailHelp" className="form-text"></div>
                    </div>
                    <div className="col align-self-end">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        CURP
                      </label>
                      <input
                        {...formik.getFieldProps("curp")}
                        {...formikExtra.upperCase("curp", formik)}
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.curp,
                        )}`}
                        id="validationEmail"
                        aria-describedby="emailHelp777"
                      />
                      <div className="valid-feedback">Looks good!</div>
                      <div className="invalid-feedback">
                        {formik.errors.curp}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col align-self-center">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Nacionalidad
                      </label>
                      <input
                        {...formik.getFieldProps("nacionalidad")}
                        {...formikExtra.upperCase("nacionalidad", formik)}
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.nacionalidad,
                        )}`}
                        id="validationEmail"
                        aria-describedby="emailHelp777"
                      />
                      <div id="emailHelp" className="form-text"></div>
                    </div>
                    <div className="col align-self-end">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Sexo
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onChange={(item) => {
                          formik.setFieldValue(
                            "sexo",
                            item.currentTarget.value,
                          );
                        }}
                      >
                        {sexos.map((item, index) => {
                          return (
                            <option
                              selected={item.name === formik.values.sexo}
                              value={index}
                            >
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback"></div>
                    </div>
                  </div>
                </div>

                <div className="">
                  <div className="separator">
                    <h5 className="card-title">
                      Direcciones
                      <span>
                        <button
                          className="btn btn-primary"
                          style={{ marginLeft: "20px" }}
                          onClick={(event) => createEditAddress(event, {})}
                        >
                          <div className={buttonStyles.icon_button}>
                            <FaPlus />
                            Agregar
                          </div>
                        </button>
                      </span>
                    </h5>
                    {direcciones?.map((item, index) => {
                      const datas = [
                        item.nombre,
                        item.cp ?? "",
                        item.calle ?? "",
                        item.estado ?? "",
                        item.ciudad ?? "",
                        item.noExterior ?? "",
                        item.noInterior ?? "",
                        item.referencia ?? "",
                      ];
                      const filtered = datas.filter((item) => item);
                      const value = filtered.join(", ");
                      return (
                        <AddressTag
                          key={index}
                          value={value}
                          item={item}
                          createEditAddress={createEditAddress}
                          deleteAddress={deleteAddress}
                          isDisable={fieldsSetup.current.direcciones}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  <LoadingButton
                    style={{ height: "38px" }}
                    onClick={(e) => {
                      formik.handleSubmit();
                      console.log("");
                      // Fetch all the forms we want to apply custom Bootstrap validation styles to
                    }}
                    text={"Guardar"}
                    loadingText={"Guardando..."}
                    isLoading={isLoading}
                    isDisable={isSaveDisable.current}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <CreateAddressModal
        ref={createAddressRef}
        returnToModalId="staticBackdropCrearAsociado"
        item={modalData}
        reloadDireccion={handleAddressViewChanges}
      />
    </>
  );
});

export default CreateAsociado;
